import { render, staticRenderFns } from "./BackLinkView.vue?vue&type=template&id=e6d2dd5a&"
import script from "./BackLinkView.vue?vue&type=script&lang=js&"
export * from "./BackLinkView.vue?vue&type=script&lang=js&"
import style0 from "./BackLinkView.vue?vue&type=style&index=0&id=e6d2dd5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports